import { CATEGORY_ROBOT_DEFAULT_VALUES } from '../constants/category';

export const formatWithCommas = (num) => {
  const rounded = Math.round(Number(num));
  return rounded.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const addUploaderHeaders = (args) => {
  const adminAuthToken = localStorage.getItem('admin-auth-token');
  const memberAuthToken = localStorage.getItem('member-auth-token');
  const sessionToken = localStorage.getItem('session-token');

  console.log('adminAuthToken', adminAuthToken);
  console.log('memberAuthToken', memberAuthToken);
  console.log('sessionToken', sessionToken);

  if (adminAuthToken) {
    args.currentRequest.setRequestHeader('Admin-Auth-Token', adminAuthToken);
  }
  if (memberAuthToken) {
    args.currentRequest.setRequestHeader('Member-Auth-Token', memberAuthToken);
  }
  if (sessionToken) {
    args.currentRequest.setRequestHeader('Authorization', `Bearer ${sessionToken}`);
  }
};

export function normalizeHostname(subUrl = null) {
  // دریافت نام دامنه فعلی
  let hostname = window.location.hostname;

  // اضافه کردن www اگر وجود نداشته باشد
  if (!hostname.startsWith('www.')) {
    hostname = 'www.' + hostname;
  }

  // ساخت URL کامل
  let fullUrl = window.location.protocol + '//' + hostname;

  // اضافه کردن زیرمسیر در صورت وجود
  if (subUrl) {
    // حذف '/' اول subUrl در صورت وجود
    subUrl = subUrl.replace(/^\//, '');

    // اضافه کردن زیرمسیر به URL
    fullUrl += '/' + subUrl;
  }

  return fullUrl;
}

export const convertStringToBoolean = (value) => {
  if (typeof value === 'boolean') return value;
  if (typeof value === 'string') {
    return value.toLowerCase() === 'true';
  }
  return Boolean(value);
};

export const cleanerRobotInfo = (options) => {
  const obj = options ? JSON.parse(options) : null;

  if (obj) {
    const isEnable = obj?.cleanupRobot
      ? convertStringToBoolean(obj.cleanupRobot)
      : CATEGORY_ROBOT_DEFAULT_VALUES.cleanup_robot;
    return {
      isNull: false,
      isEnable,
      limit: obj?.cleanupLimit ? parseInt(obj.cleanupLimit, 10) : CATEGORY_ROBOT_DEFAULT_VALUES.cleanup_limit,
      state: obj?.state ?? {},
    };
  } else {
    return {
      isNull: true,
      isEnable: false,
      limit: 0,
      state: {},
    };
  }
};
